import Image from 'next/image';
import React, { useState } from 'react';
import { useCookies } from 'react-cookie';
import { TailSpin } from 'react-loader-spinner';
import styled from 'styled-components';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { getFullLicense } from '../../../api/bots';
import { COOKIE } from '../../../constants';
import { TidalButton } from '../../common/button';
import { TidalTag } from '../../common/tag';
import Bin from '../../svgs/Bin';
import Eye from '../../svgs/Eye';
import Key from '../../svgs/Key';
import Pencil from '../../svgs/Pencil';
import { useRouter } from 'next/router';
import dayjs from 'dayjs';
import imageUrl from '../../../lib/image-url';

const TidalDashboarServerCardWrapper = styled.div`
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0px 10px 49px rgb(0 27 31 / 8%);
  padding: 23px 25px;
  width: 100%;
  border: 1px solid #e6e6e6;
  padding: 25px 23px;
  @media only screen and (max-width: 1100px) {
    box-shadow: 0 0 0;
  }
  @media only screen and (max-width: 370px) {
    padding: 16px;
  }
`;

const TidalDashboardBotVaultCardHeader = styled.div`
  display: grid;
  grid-template-columns: 100px 1fr;
  grid-gap: 19px;
  .tidal-server-image {
    border-radius: 10px;
    background-color: black;
  }
  @media only screen and (max-width: 400px) {
    display: block;
    .tidal-dashboard-server-header-details {
      margin-top: 16px;
    }
  }
  .tidal-dashboard-server-header-details {
    .tidal-dashboard-server-header-details-top {
      display: flex;
      justify-content: space-between;
      @media only screen and (max-width: 320px) {
        display: block;
      }
      .actions-row {
        display: flex;
        align-items: flex-start;
        grid-gap: 8px;
      }
      .name {
        font-weight: 700;
        font-size: 18px;
        line-height: 22px;
        color: ${(props) => props.theme.colors.text[2]};
      }
      .expires {
        margin-top: 5px;
        font-weight: 600;
        font-size: 12px;
        color: ${(props) => props.theme.colors.text[0]};
        height: 36px;
        overflow: hidden;
      }
    }
    .tidal-dashboard-server-header-details-bottom {
      margin-top: 10px;
      height: 30px;
      .remaining-days-count {
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        color: ${(props) => props.theme.colors.text[2]};
      }
    }
  }
`;

const TidalDashboardBotVaultProgressBar = styled.div<{
  progress: number;
}>`
  width: 100%;
  .progress-bar-container {
    width: 100%;
    position: relative;
    background: #f2f4f9;
    border-radius: 40px;
    height: 7px;
    margin-top: 8px;
  }
  .progress-bar {
    height: 7px;
    position: absolute;
    background: #1cbaf0;
    border-radius: 40px;
    width: ${(props) => props.progress}%;
  }
`;

const TidalDashboardBotVaultCardBody = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors.borderColors[1]};
  border-bottom: 1px solid ${(props) => props.theme.colors.borderColors[1]};
  margin: 20px 0;
  margin-bottom: 0px;
  padding: 10px 0;
  & > .tidal-dashboard-vault-card-key-row {
    display: grid;
    grid-template-columns: 40px 1fr 16px;
    align-items: center;
    grid-gap: 11px;
    @media only screen and (max-width: 320px) {
      grid-template-columns: 30px 1fr 16px;
    }
    & > .key-icon-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      height: 40px;
      width: 40px;
      @media only screen and (max-width: 320px) {
        width: 30px;
        height: 30px;
      }
      background-color: ${(props) => props.theme.colors.tags[5]};
    }
    & > .key-wrapper {
      margin-right: 16px;
      & > .label {
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        color: ${(props) => props.theme.colors.text[0]};
      }
      .license-key-text {
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        color: ${(props) => props.theme.colors.text[1]};
      }
      & > .key-row {
        display: flex;
        align-items: center;
        grid-gap: 4px;

        .obstructed-pattern {
          display: flex;
          grid-gap: 3px;
          wrap: nowrap;
          .cirle {
            height: 5px;
            width: 5px;
            border-radius: 50%;
            background-color: ${(props) => props.theme.colors.text[0]};
          }
        }
      }
    }
  }
`;

const TidalDashboardBotVaultCardFooter = styled.div`
  display: grid;
  grid-template-columns: 1fr;
`;

const TidalDashboardBotVaultTagsContainer = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.colors.borderColors[1]};
  padding: 10px 0;
  min-height: 32px;
  margin-bottom: 18px;
  & > .title {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 12px;
    color: ${(props) => props.theme.colors.text[2]};
  }
  & > .tidal-dashboard-bot-vault-tags-row {
    display: flex;
    grid-gap: 8px;
  }
`;

const TidalDashboardBotVaultCardObfuscateButton = styled.button``;

interface ITidalDashboardBotVaultCard {
  image: string;
  name: string;
  rentalId: string;
  expires: string;
  licenseKey: string;
  tags: any[];
  licenseType: string;
  id: string;
  startDate: string;
  onDelete: () => void;
  onEdit: () => void;
}

const TidalDashboardBotVaultCard = ({
  image,
  name,
  expires,
  licenseKey,
  licenseType,
  tags,
  startDate,
  id,
  rentalId,
  onDelete,
  onEdit,
}: ITidalDashboardBotVaultCard): JSX.Element => {
  const [isObfuscated, setIsObfuscated] = React.useState(true);
  const [fullLicenseKey, setFullLicenseKey] = useState('');
  const [isFullKeyLoading, setIsFullKeyLoading] = useState(false);
  const router = useRouter();

  const renderTag = (tag) => {
    switch (tag) {
      case 1:
        return <TidalTag type={'success'} title={'Holding'} />;
      case 2:
        return <TidalTag type={'primary'} title={'Using'} />;
      case 3:
        return <TidalTag type={'warning'} title={'Renting'} />;
      case 4:
        return <TidalTag type={'info'} title={'Selling'} />;
      case 5:
        return <TidalTag type={'error'} title={'Sold'} />;
      default:
        return <div style={{ height: 26 }}> N/A</div>;
    }
  };

  const handleGetFullLicenseKey = async () => {
    setIsFullKeyLoading(true);
    try {
      const res = await getFullLicense({
        licenseId: id,
      });
      setFullLicenseKey(res.licenseKey);
    } catch (e) {}
    setIsFullKeyLoading(false);
  };

  const getDaysRemaining = () => {
    const endDate = dayjs(new Date(expires));
    const now = dayjs(new Date());

    const difference = endDate.startOf('day').diff(now.startOf('day'), 'days');

    const daysRemaining = parseInt(endDate.diff(now, 'days').toFixed());

    if (daysRemaining > 0) {
      const percentageOfRemainingDays = (daysRemaining / difference) * 100;
      return {
        totalDays: difference,
        daysRemaining,
        percentageOfRemainingDays,
      };
    } else {
      return {
        totalDays: 0,
        daysRemaining: 0,
        percentageOfRemainingDays: 0,
      };
    }
  };

  return (
    <TidalDashboarServerCardWrapper>
      <TidalDashboardBotVaultCardHeader>
        <Image
          className="tidal-server-image"
          src={imageUrl(`bots/${image}`)}
          alt={`${name} image`}
          width={85}
          height={85}
        />
        <div className="tidal-dashboard-server-header-details">
          <div className="tidal-dashboard-server-header-details-top">
            <div>
              <p className="name">{name}</p>
              <p className="expires">
                Expires:{' '}
                {licenseType == 'lifetime'
                  ? 'Lifetime'
                  : new Date(expires).toDateString()}
              </p>
            </div>
            <div className="actions-row">
              <button aria-label="edit" onClick={onEdit}>
                <Pencil />
              </button>
              <button aria-label="delete" onClick={onDelete}>
                <Bin />
              </button>
            </div>
          </div>
          {licenseType != 'lifetime' ? (
            <div className="tidal-dashboard-server-header-details-bottom">
              <p className="remaining-days-count ">
                {getDaysRemaining().daysRemaining} days remaining
              </p>
              <TidalDashboardBotVaultProgressBar
                progress={getDaysRemaining().percentageOfRemainingDays}
              >
                <div className="progress-bar-container">
                  <div className="progress-bar" />
                </div>
              </TidalDashboardBotVaultProgressBar>
            </div>
          ) : (
            <div className="tidal-dashboard-server-header-details-bottom" />
          )}
        </div>
      </TidalDashboardBotVaultCardHeader>
      <TidalDashboardBotVaultCardBody>
        <div className="tidal-dashboard-vault-card-key-row">
          <div className="key-icon-wrapper">
            <Key />
          </div>
          <div className="key-wrapper">
            <p className="label">License Key</p>
            {isObfuscated && (
              <div className="key-row">
                <div className="obstructed-pattern">
                  {Array(
                    Math.ceil(licenseKey.length - licenseKey.length / 4) - 1,
                  )
                    .fill(0)
                    .map((a) => (
                      <div className="cirle"></div>
                    ))}
                </div>
                <p className="license-key-text">{licenseKey}</p>
              </div>
            )}
            {!isObfuscated && isFullKeyLoading && (
              <div>
                <TailSpin color="#0000ff" height={16} width={16} />
              </div>
            )}
            {!isObfuscated && (
              <p className="license-key-text">{fullLicenseKey}</p>
            )}
          </div>
          <TidalDashboardBotVaultCardObfuscateButton
            aria-label="obfuscate"
            onClick={() => {
              if (isObfuscated && fullLicenseKey.length == 0) {
                handleGetFullLicenseKey();
              }
              setIsObfuscated(!isObfuscated);
            }}
          >
            <Eye />
          </TidalDashboardBotVaultCardObfuscateButton>
        </div>
      </TidalDashboardBotVaultCardBody>
      <TidalDashboardBotVaultTagsContainer>
        <p className="title">Tags</p>
        <div className="tidal-dashboard-bot-vault-tags-row">
          {tags.map((tag) => renderTag(tag))}
        </div>
      </TidalDashboardBotVaultTagsContainer>
      <TidalDashboardBotVaultCardFooter>
        {rentalId ? (
          <TidalButton
            type="info"
            text="List to Rent"
            tint={false}
            onClick={() => {
              router.push(`/bots/new-create-listing?botId=${rentalId}`);
            }}
          />
        ) : (
          <TidalButton
            type="info"
            text="Unsupported"
            tint={false}
            disabled={true}
          />
        )}
      </TidalDashboardBotVaultCardFooter>
    </TidalDashboarServerCardWrapper>
  );
};

export default TidalDashboardBotVaultCard;
